import { WorkerRequirementStatus } from "@clipboard-health/contract-worker-app-bff";
import { type ChipProps } from "@mui/material";

import {
  type OnboardingRequirementStatus,
  OnboardingRequirementStatuses,
} from "../../hooks/useOnboardingRequirement";

const defaultChipProps = {
  position: "absolute",
  right: "1rem",
  top: "0.75rem",
} satisfies ChipProps["sx"];

const CHIP_PROPS: Record<string, ChipProps> = {
  approved: {
    label: "Approved",
    sx: {
      backgroundColor: (theme) => theme.palette.intent?.success.background,
      color: (theme) => theme.palette.intent?.success.text,
      ...defaultChipProps,
    },
  },
  inReview: {
    label: "In review",
    sx: {
      backgroundColor: (theme) => theme.palette.intent?.neutral.background,
      color: (theme) => theme.palette.intent?.neutral.text,
      ...defaultChipProps,
    },
  },
  rejected: {
    label: "Rejected",
    sx: {
      backgroundColor: (theme) => theme.palette.intent?.error.background,
      color: (theme) => theme.palette.intent?.error.text,
      ...defaultChipProps,
    },
  },
  expired: {
    label: "Expired",
    sx: {
      backgroundColor: (theme) => theme.palette.intent?.error.background,
      color: (theme) => theme.palette.intent?.error.text,
      ...defaultChipProps,
    },
  },
  expiring: {
    label: "Expiring",
    sx: {
      backgroundColor: (theme) => theme.palette.intent?.warning.background,
      color: (theme) => theme.palette.intent?.warning.text,
      ...defaultChipProps,
    },
  },
};

export function getChipProps(status: OnboardingRequirementStatus): ChipProps | undefined {
  if (status === OnboardingRequirementStatuses.COMPLETED) {
    return CHIP_PROPS.approved;
  }

  if (status === OnboardingRequirementStatuses.IN_PROGRESS) {
    return CHIP_PROPS.inReview;
  }

  if (status === OnboardingRequirementStatuses.REJECTED) {
    return CHIP_PROPS.rejected;
  }

  if (status === OnboardingRequirementStatuses.EXPIRED) {
    return CHIP_PROPS.expired;
  }

  if (status === OnboardingRequirementStatuses.EXPIRING) {
    return CHIP_PROPS.expiring;
  }

  return undefined;
}

export function getWorkerRequirementChipProps(
  status: WorkerRequirementStatus
): ChipProps | undefined {
  if (status === WorkerRequirementStatus.APPROVED) {
    return CHIP_PROPS.approved;
  }

  if (status === WorkerRequirementStatus.IN_REVIEW) {
    return CHIP_PROPS.inReview;
  }

  if (status === WorkerRequirementStatus.REJECTED) {
    return CHIP_PROPS.rejected;
  }

  if (status === WorkerRequirementStatus.EXPIRED) {
    return CHIP_PROPS.expired;
  }

  if (status === WorkerRequirementStatus.EXPIRING) {
    return CHIP_PROPS.expiring;
  }

  return undefined;
}
